/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { track as rudderstackTrack } from "common/utils/rudderstack/tracker.react";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import CanvaButton from "components/jiffy/react-canva-button/CanvaButton.vue";

export default function MobileStickyCtaDtf({
  isUserSignedIn = false,
  canvaDtfEnabled,
  fileLanding,
  namespace,
  onUploadImageClick,
  onArtworkHistoryClick,
  // @ts-expect-error TS(6133): 'restProps' is declared but its value is never rea... Remove this comment to see the full error message
  ...restProps
}: any) {
  function shouldShowCanvaButton() {
    return canvaDtfEnabled && isUserSignedIn;
  }

  function trackStickyCtaInteraction(buttonType: any) {
    const commonProperties = {
      button_type: buttonType,
      user_authenticated: isUserSignedIn,
      page_type: "pdp",
      device_type: "mobile"
    };
    submitDtfEvent("sticky_cta_interaction", commonProperties);
    rudderstackTrack("Mobile CTA Button Clicked", commonProperties);
  }

  function handleUploadImageClick() {
    trackStickyCtaInteraction("upload_image");
    onUploadImageClick?.();
  }

  function handleArtworkHistoryClick() {
    trackStickyCtaInteraction("design_library");
    onArtworkHistoryClick?.();
  }

  function handleLoginSignupClick() {
    trackStickyCtaInteraction("login_signup");
  }

  function handleCanvaClick() {
    trackStickyCtaInteraction("canva");
  }

  return (
    <>
      {}
      <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-white px-2 py-2.5">
        <div className="flex gap-2">
          <button
            className="h-11 flex-1 rounded-md bg-gray-900 px-4 text-sm !font-semibold !text-white"
            type="button"
            data-testid="mobile-upload-image-btn"
            onClick={handleUploadImageClick}
          >
            {" "}
            Upload Image{" "}
          </button>
          {isUserSignedIn ? (
            <>
              <button
                className="h-11 flex-1 rounded-md border border-black bg-white px-4 text-sm !font-semibold !text-black"
                type="button"
                data-testid="mobile-design-library-btn"
                onClick={handleArtworkHistoryClick}
              >
                {" "}
                Design Library{" "}
              </button>
              {shouldShowCanvaButton() ? (
                <div
                  className="flex h-11 flex-1 items-center justify-center rounded-md border border-black bg-white px-4 text-sm !font-semibold !text-black"
                  data-testid="mobile-canva-btn"
                >
                  <CanvaButton
                    fileLanding={fileLanding}
                    namespace={namespace}
                    onClick={handleCanvaClick}
                    data-testid="canva-button"
                  />
                </div>
              ) : null}
            </>
          ) : (
            <a
              className="flex h-11 flex-1 items-center justify-center rounded-md border border-black bg-white px-4 text-sm !font-semibold !text-black no-underline"
              href="/login"
              data-testid="mobile-login-btn"
              onClick={handleLoginSignupClick}
            >
              {" "}
              Log In / Sign Up{" "}
            </a>
          )}
        </div>
        {!isUserSignedIn && canvaDtfEnabled ? (
          <div className="mt-2 text-center">
            <span className="flex items-center justify-center gap-1 text-sm font-normal !text-black">
              {" "}
              Log in to access your{" "}
              <div className="brightness-0 saturate-100 filter" data-testid="brightness-0">
                <UseSvg icon="canva" width={46} height={15} data-testid="use-svg" />
              </div>{" "}
              workspace.{" "}
            </span>
          </div>
        ) : null}
      </div>
    </>
  );
}
